<script>
	import Button from '$lib/Components/Layout/Button/Button.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import homepage from '$routes/(public)/pricing-change/images/IMG_5165.jpg';
</script>

<Section
	backgroundImage={homepage}
	backgroundImageContainerClass="md:h-auto!"
	backgroundColor="blue"
	class="min-h-[clamp(20rem,66dvh,33dvw)]"
	innerClass="max-w-[90ch] !justify-items-start !py-0 full-width"
	loading="eager"
>
	<div
		class="
    col-start-1! hidden h-full content-center gap-6 self-start bg-indow-blue/80
    p-8
    md:grid
  "
	>
		<p
			class="
     mb-0 max-w-[14ch] place-self-start px-6 pt-0 text-left text-3xl font-medium
     hyphens-none text-white
   "
		>
			An Update on Our Pricing
		</p>
		<p
			class="
     m-0 max-w-80 place-self-start px-6 text-left text-xl font-medium
     text-balance text-white
   "
		>
			Our prices are increasing soon. Secure an estimate today to take advantage
			of our current pricing.
		</p>
		<span
			class="
     place-self-end
     md:place-self-start md:px-6
   "
		>
			<Button
				class="
      place-self-end self-start
      md:place-self-start
    "
				href="/pricing-change">GET AN ESTIMATE</Button
			>
		</span>
	</div>
</Section>
<Section backgroundColor="grey-medium" class="md:hidden!">
	<p class="text-3xl font-bold text-balance text-indow-white">
		An Update on Our Pricing
	</p>
	<p class="font-medium text-balance text-indow-white">
		Our prices are increasing soon. Secure an estimate today to take advantage
		of our current pricing.
	</p>
	<Button href="/pricing-change">GET AN ESTIMATE</Button>
</Section>
